module.exports = __webpack_public_path__ + "static/media/1009386.7fcb712f.png";